<template>
  <span>{{ value }}</span>
</template>
<script>
import { defineComponent } from 'vue'
export default defineComponent({
  // props: {
  //   params: {
  //     type: Object,
  //     default: null
  //   }
  // },
  data() {
    return {
      value: '',
      type: 'text',
      colName: null
    }
  },
  methods: {},
  beforeMount() {
    console.log('check params prop in đílap', this.params)
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value.toLocaleString('en-US')
    }
    // console.log('HAHAHAAAAAA:', this.params)
    this.params.type ? (this.type = this.params.type) : null
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  }
})
</script>

<style></style>
